export * from './lib/icon.module';
export * from './lib/icon.component';
